import { useCallback, useEffect, useRef, useState } from 'react';

export type UseMinWidthExceeded = {
  disabled?: boolean;
  innerElementId: string;
};

export const useMinWidthExceeded = ({
  disabled = false,
  innerElementId,
}: UseMinWidthExceeded) => {
  const elementRef = useRef<HTMLDivElement | null>(null);
  const [ minWidthExceeded, setMinWidthExceeded ] = useState(false);

  const callback = useCallback((entries: ResizeObserverEntry[]) => {
    const currentColumnsWidthTotal = (window.document.getElementById(innerElementId) as HTMLElement)?.offsetWidth ?? 0;

    const { width } = entries[0].contentRect;

    const minWidthExceeded = width <= (currentColumnsWidthTotal - 5);

    setMinWidthExceeded(minWidthExceeded);
  }, [ innerElementId ]);

  useEffect(() => {
    if (disabled) return;

    const observer = new ResizeObserver(callback);

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    const current = elementRef.current;

    return () => {
      if (current) {
        observer.unobserve(current);
      }
    };
  }, [ callback, disabled ]);

  return { elementRef, minWidthExceeded };
};
